export default __webpack_public_path__ + "img/partnership4-1c5a17a1823a76746b2a95a03b3751a2.png";